import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet-async';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import 'react-datepicker/dist/react-datepicker.css';
import { Link as RouterLink, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import $ from 'jquery';
import TableToExcel from '@linways/table-to-excel';
import * as XLSX from 'xlsx';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from '../../config';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../common.scss';
import { encryptData } from '../../utils/cryptoUtils';
import * as userActions from '../../actions/userActions';
import * as leadActions from '../../actions/leadActions';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const LeadChecklistDynamicScore = ({ props, allLeadCheckListDynamicScore, setOpen, leadId, allLeadCheckLists, userRoleType, creditAllLeadCheckLists, scoreCard, allLeadCheckListScore, actions }) => {

    // const [allLeadScore, setAllLeadScore] = useState([]);
    // const [leadTotalScore, setLeadTotalScore] = useState('Not Found');
    // const [leadIdValue, setLeadIdValue] = useState('');
    // const [scoreData, setScoreData] = useState([]);
    // const [scoreDataFormate, setScoreDataFormate] = useState(false);
    // const [exportExcelFileButtonVisible, setExportExcelFileButtonVisible] = useState(false);
    const [fiSheetCheckId, setFiSheetCheckId] = useState(config.FI_SHEET_CHECK_ID);
    // const [creditScoreCard, setCreditScoreCard] = useState("");
    // const [allCreditLeadScore, setAllCreditLeadScore] = useState([]);
    // const [leadCreditTotalScore, setLeadCreditTotalScore] = useState('Not Found');

    // const [lastUpdateBy, setLastUpdateBy] = useState('Not Found');
    // const [lastUpdateDate, setLastUpdateDate] = useState('Not Found');
    // const [showSalesTotalScoreValue, setSalesShowTotalScoreValue] = useState(false);
    // const [showCreditTotalScoreValue, setCreditShowTotalScoreValue] = useState(false);
    // const [excelData, setExcelData] = useState(null);
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const [tvrData, SetTvrData] = useState([]);
    const [getTvrData, SetGetTvrData] = useState([]);

    const storedScoreData = {};
    const navigate = useNavigate();

    useEffect(() => {
        getEditTvrData();
      }, [leadId]); 


       const getEditTvrData = async () => {
            const obj = {
                "lead_id": leadId
            }
            const requestData = encryptData(obj);
            const response = actions.addEditLeadChecklistTvr1(requestData);
            response.then((result) => {
                const fetchedData = result.data.data.data[0];
                SetGetTvrData(fetchedData);

                setValue("customer_name", fetchedData.customer_name || "");
                setValue("applicantProfile", fetchedData.applicantProfile || "");
                setValue("commercialDriving", fetchedData.commercialDriving || "");
                setValue("coApplicantProfile", fetchedData.coApplicantProfile || "");
                setValue("gurantorProfile", fetchedData.gurantorProfile || "");
                setValue("propertyOwnership", fetchedData.propertyOwnership || "");
                setValue("currentResident", fetchedData.currentResident || "");
                setValue("residenceDistance", fetchedData.residenceDistance || "");
                setValue("financialDetail", fetchedData.financialDetail || "");
                setValue("gstRegister", fetchedData.gstRegister || "");
                setValue("shopEstablishment", fetchedData.shopEstablishment || "");
                setValue("fleetList", fetchedData.fleetList || "");
                setValue("workOrder", fetchedData.workOrder || "");
                setValue("businessVintage", fetchedData.businessVintage || "");
                setValue("netProMagin", fetchedData.netProMagin || "");
                setValue("deploymentDetail", fetchedData.deploymentDetail || "");
                setValue("cibilDetail", fetchedData.cibilDetail || "");
                setValue("cibilDetailCoApplicant", fetchedData.cibilDetailCoApplicant || "");
                setValue("cibilDetailGurantor", fetchedData.cibilDetailGurantor || "");
                setValue("incomeDetails", fetchedData.incomeDetails || "");
                setValue("incomeDetailApplicant", fetchedData.incomeDetailApplicant || "");
                setValue("incomeDetailGurantor", fetchedData.incomeDetailGurantor || "");
                setValue("fiRemarks", fetchedData.fiRemarks || "");
                setValue("referenceCheck", fetchedData.referenceCheck || "");
                setValue("vehicleUsage", fetchedData.vehicleUsage || "");
                setValue("costVehicle", fetchedData.costVehicle || "");
                setValue("dp", fetchedData.dp || "");
                setValue("tenor", fetchedData.tenor || "");
                setValue("emiDetails", fetchedData.emiDetails || "");

            }).catch((error) => {
            toast.error(error, {
                position: "top-right",
            });
        });
       }
      
    const onSubmit = (data) =>{
        const idValue = getTvrData.id;
        const params = { 
            "id": idValue,
            "lead_id": leadId, 
            "customer_name": data.customer_name, 
            "applicantProfile": data.applicantProfile, 
            "commercialDriving": data.commercialDriving,
            "coApplicantProfile": data.coApplicantProfile, 
            "gurantorProfile": data.gurantorProfile, 
            "propertyOwnership": data.propertyOwnership, 
            "currentResident": data.currentResident, 
            "residenceDistance": data.residenceDistance, 
            "financialDetail": data.financialDetail, 
            "gstRegister": data.gstRegister, 
            "shopEstablishment": data.shopEstablishment, 
            "fleetList": data.fleetList, 
            "workOrder": data.workOrder, 
            "businessVintage": data.businessVintage, 
            "netProMagin": data.netProMagin, 
            "deploymentDetail": data.deploymentDetail, 
            "cibilDetail": data.cibilDetail, 
            "cibilDetailCoApplicant": data.cibilDetailCoApplicant, 
            "cibilDetailGurantor": data.cibilDetailGurantor, 
            "incomeDetails": data.incomeDetails, 
            "incomeDetailApplicant": data.incomeDetailApplicant, 
            "incomeDetailGurantor": data.incomeDetailGurantor, 
            "fiRemarks": data.fiRemarks, 
            "referenceCheck": data.referenceCheck, 
            "vehicleUsage": data.vehicleUsage, 
            "costVehicle": data.costVehicle, 
            "dp": data.dp, 
            "tenor": data.tenor, 
            "emiDetails": data.emiDetails, 
        };

        const requestData = encryptData(params);
        const response = actions.addEditLeadChecklistTvr(requestData);
        response.then((result) => {
            if (result.data.success === 1) {
                toast.success(result.data.message, {
                    position: "top-right",
                });
                // SetTvrData    
                setTimeout(() => {
                    navigate("/dashboard/leads");
                
                }, 1000); 
            } 
            
            else{
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
            toast.error(error, {
                position: "top-right",
            });
        });
    }

    return (
        <>
        <h5 className="fw-bold">TVR Details</h5>
              <div id="main-wrap" className='mt-4'>
                <div className='row justify-content-between'>

                    {/* <div className="row mb-2">
                      <div className="col-md-12">
                        <div className="form-group mb-0">
                          <button className="btn btn-primary" onClick={getEditTvrData}>Edit Data</button>
                        </div>
                      </div>
                    </div> */}
        
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        
                        <div className='col-md-4'>
                            <div className='form-group'>    
                            <label htmlFor="customer_name">
                                <span>Customer Name</span>
                                <input className='form-control' id='customer_name' name='customer_name'
                                {...register('customer_name')} 
                                // value={getTvrData.customer_name}
                                defaultValue={getTvrData.customer_name || ""} 
                                onChange={(e) => setValue('customer_name', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>
                        {/* <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="id">
                                <span>Id</span>
                                <input className='form-control' id='id' name='id' {...register('id')}       
                                // value={getTvrData.id}
                                defaultValue={getTvrData.id} 
                                onChange={(e) => setValue('id', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div> */}
                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="applicantProfile">
                                <span>Applicant Profile & Details</span>
                                <input className='form-control' id='applicantProfile' name='applicantProfile' {...register('applicantProfile')} 
                                // value={getTvrData.applicantProfile}
                                defaultValue={getTvrData.applicantProfile || ""} 
                                onChange={(e) => setValue('applicantProfile', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="commercialDriving">
                                <span>Commercial Driving Exp(DL / Learning / Applied)</span>
                                <input className='form-control' id='commercialDriving' name='commercialDriving' {...register('commercialDriving')} 
                                // value={getTvrData.commercialDriving}
                                defaultValue={getTvrData.commercialDriving || ""} 
                                onChange={(e) => setValue('commercialDriving', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="coApplicantProfile">
                                <span>Co-Applicant Profile & Address Details</span>
                                <input className='form-control' id='coApplicantProfile' name='coApplicantProfile' {...register('coApplicantProfile')} 
                                // value={getTvrData.coApplicantProfile}
                                defaultValue={getTvrData.coApplicantProfile || ""} 
                                onChange={(e) => setValue('coApplicantProfile', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="gurantorProfile">
                                <span>Guarantor Profile & Address details</span>
                                <input className='form-control' id='gurantorProfile' name='gurantorProfile' {...register('gurantorProfile')} 
                                // value={getTvrData.gurantorProfile}
                                defaultValue={getTvrData.gurantorProfile || ""} 
                                onChange={(e) => setValue('gurantorProfile', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="propertyOwnership">
                                <span>Property Ownership Details (Owned / parental owned / rented/ relative owned)e</span>
                                <input className='form-control' id='propertyOwnership' name='propertyOwnership' {...register('propertyOwnership')} 
                                // value={getTvrData.propertyOwnership}
                                defaultValue={getTvrData.propertyOwnership || ""} 
                                onChange={(e) => setValue('propertyOwnership', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="currentResident">
                                <span>Current Residential and City Stability</span>
                                <input className='form-control' id='currentResident' name='currentResident' {...register('currentResident')}
                                //  value={getTvrData.currentResident}
                                defaultValue={getTvrData.currentResident || ""} 
                                onChange={(e) => setValue('currentResident', e.target.value)}  
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="residenceDistance">
                                <span>Residence distance from cKers  Branch or Dealership</span>
                                <input className='form-control' id='residenceDistance' name='residenceDistance' {...register('residenceDistance')} 
                                // value={getTvrData.residenceDistance}
                                defaultValue={getTvrData.residenceDistance || ""} 
                                onChange={(e) => setValue('residenceDistance', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="financialDetail">
                                <span>Financials Details</span>
                                <input className='form-control' id='financialDetail' name='financialDetail' {...register('financialDetail')} 
                                // value={getTvrData.financialDetail}
                                defaultValue={getTvrData.financialDetail || ""} 
                                onChange={(e) => setValue('financialDetail', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="gstRegister">
                                <span>GST Registered</span>
                                <input className='form-control' id='gstRegister' name='gstRegister'
                                {...register('gstRegister')} 
                                // value={getTvrData.gstRegister}
                                defaultValue={getTvrData.gstRegister || ""} 
                                onChange={(e) => setValue('gstRegister', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="shopEstablishment">
                                <span>Shop Establishment Details</span>
                                <input className='form-control' id='shopEstablishment' name='shopEstablishment' {...register('shopEstablishment')} 
                                //  value={getTvrData.shopEstablishment}
                                defaultValue={getTvrData.shopEstablishment || ""} 
                                onChange={(e) => setValue('shopEstablishment', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="fleetList">
                                <span>Fleet list</span>
                                <input className='form-control' id='fleetList' name='fleetList' {...register('fleetList')}
                                //  value={getTvrData.fleetList}
                                 defaultValue={getTvrData.fleetList || ""} 
                                 onChange={(e) => setValue('fleetList', e.target.value)}
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="workOrder">
                                <span>Work order / Contract letter / owned usage</span>
                                <input className='form-control' id='workOrder' name='workOrder' {...register('workOrder')} 
                                // value={getTvrData.workOrder}
                                defaultValue={getTvrData.workOrder || ""} 
                                onChange={(e) => setValue('workOrder', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="businessVintage">
                                <span>Business Vintage</span>
                                <input className='form-control' id='businessVintage' name='businessVintage' {...register('businessVintage')} 
                                // value={getTvrData.businessVintage}
                                defaultValue={getTvrData.businessVintage || ""} 
                                onChange={(e) => setValue('businessVintage', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="netProMagin">
                                <span>Net Profit Margin</span>
                                <input className='form-control' id='netProMagin' name='netProMagin' {...register('netProMagin')} 
                                // value={getTvrData.netProMagin}
                                defaultValue={getTvrData.netProMagin || ""} 
                                onChange={(e) => setValue('netProMagin', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="deploymentDetail">
                                <span>Deployment Details & Viability</span>
                                <input className='form-control' id='deploymentDetail' name='deploymentDetail' {...register('deploymentDetail')} 
                                // value={getTvrData.deploymentDetail}
                                defaultValue={getTvrData.deploymentDetail || ""} 
                                onChange={(e) => setValue('deploymentDetail', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="cibilDetail">
                                <span>CIBIL Details of applicant</span>
                                <input className='form-control' id='cibilDetail' name='cibilDetail' {...register('cibilDetail')} 
                                // value={getTvrData.cibilDetail}
                                defaultValue={getTvrData.cibilDetail || ""} 
                                onChange={(e) => setValue('cibilDetail', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="cibilDetailCoApplicant">
                                <span>CIBIL Details of co-applicant</span>
                                <input className='form-control' id='cibilDetailCoApplicant' name='cibilDetailCoApplicant' {...register('cibilDetailCoApplicant')}    
                                // value={getTvrData.cibilDetailCoApplicant}
                                 defaultValue={getTvrData.cibilDetailCoApplicant || ""} 
                                 onChange={(e) => setValue('cibilDetailCoApplicant', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="cibilDetailGurantor">
                                <span>CIBIL Details of Guarantor</span>
                                <input className='form-control' id='cibilDetailGurantor' name='cibilDetailGurantor' {...register('cibilDetailGurantor')} 
                                //    value={getTvrData.cibilDetailGurantor}
                                defaultValue={getTvrData.cibilDetailGurantor || ""} 
                                onChange={(e) => setValue('cibilDetailGurantor', e.target.value)} 
                                />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="incomeDetails">
                                <span>Income Details - Applicant (Including banking details)</span>
                                <input className='form-control' id='incomeDetails' name='incomeDetails' {...register('incomeDetails')} 
                                // value={getTvrData.incomeDetails}  
                                defaultValue={getTvrData.incomeDetails || ""} 
                                onChange={(e) => setValue('incomeDetails', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="incomeDetailApplicant">
                                <span>Income Details - Co- Applicant</span>
                                <input className='form-control' id='incomeDetailApplicant' name='incomeDetailApplicant' {...register('incomeDetailApplicant')}       
                                // value={getTvrData.incomeDetailApplicant} 
                                 defaultValue={getTvrData.incomeDetailApplicant || ""} 
                                 onChange={(e) => setValue('incomeDetailApplicant', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="incomeDetailGurantor">
                                <span>Income Details - Guarantor</span>
                                <input className='form-control' id='incomeDetailGurantor' name='incomeDetailGurantor' {...register('incomeDetailGurantor')} 
                                // value={getTvrData.incomeDetailGurantor}
                                defaultValue={getTvrData.incomeDetailGurantor || ""} 
                                onChange={(e) => setValue('incomeDetailGurantor', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="fiRemarks">
                                <span>FI Remarks</span>
                                <input className='form-control' id='fiRemarks' name='fiRemarks' {...register('fiRemarks')} 
                                // value={getTvrData.fiRemarks}
                                defaultValue={getTvrData.fiRemarks || ""} 
                                onChange={(e) => setValue('fiRemarks', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="referenceCheck">
                                <span>References Checks</span>
                                <input className='form-control' id='referenceCheck' name='referenceCheck' {...register('referenceCheck')} 
                                // value={getTvrData.referenceCheck}
                                defaultValue={getTvrData.referenceCheck || ""} 
                                onChange={(e) => setValue('referenceCheck', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="vehicleUsage">
                                <span>Vehicle Usage</span>
                                <input className='form-control' id='vehicleUsage' name='vehicleUsage' {...register('vehicleUsage')} 
                                // value={getTvrData.vehicleUsage}
                                defaultValue={getTvrData.vehicleUsage || ""} 
                                onChange={(e) => setValue('vehicleUsage', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="costVehicle">
                                <span>Cost Of vehicle and Model</span>
                                <input className='form-control' id='costVehicle' name='costVehicle'  {...register('costVehicle')} 
                                // value={getTvrData.costVehicle}
                                defaultValue={getTvrData.costVehicle || ""} 
                                onChange={(e) => setValue('costVehicle', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="dp">
                                <span>DP</span>
                                <input className='form-control' id='dp' name='dp' {...register('dp')}     
                                // value={getTvrData.dp}
                                 defaultValue={getTvrData.dp || ""} 
                                 onChange={(e) => setValue('dp', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="tenor">
                                <span>Tenor</span>
                                <input className='form-control' id='tenor' name='tenor' {...register('tenor')} 
                                // value={getTvrData.tenor}
                                defaultValue={getTvrData.tenor || ""} 
                                onChange={(e) => setValue('tenor', e.target.value)} />
                            </label>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='form-group'>
                            <label htmlFor="emiDetails">
                                <span>EMI Details</span>
                                <input className='form-control' id='emiDetails' name='emiDetails' {...register('emiDetails')} 
                                // value={getTvrData.emiDetails}
                                defaultValue={getTvrData.emiDetails || ""} 
                                onChange={(e) => setValue('emiDetails', e.target.value)} />
                            </label>
                            </div>
                        </div>
                    </div>
        
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group mb-0">
                          <button className="btn btn-primary">Submit</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
        </>
    );
};

function mapStateToProps(state) {
    return {
        usersData: state.usersData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(userActions.default, leadActions.default), dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(LeadChecklistDynamicScore);
